import { vuexPto } from '@/store/compositionV2/module/pto'
import workSign from '@/store/modules/pto/project/estimate/workSign'
import ownProduction from '@/store/modules/pto/project/estimate/ownProduction'
import fotProduction from '@/store/modules/pto/project/estimate/fotProduction'
import { PTOEstimateApi } from '@/api/pto/project/estimate'
import { getUserFullName } from '@/utils/user'
import { priceFormat } from '@/utils/form/priceFormat'
import { mapEstimateBaseTypeItem } from '@/utils/page/pto/project/pto/map'
import { EPtoHandbookEstimateBaseTypeName } from '@/api/pto'

const state = () => ({
  ...vuexPto.createState(),
  api: PTOEstimateApi,
  namePageDetailed: 'PtoProjectEstimateUpdate',
  expand: 'mol,base',
  tableHeaders: [
    {
      title: 'Смета',
      isSortable: true,
      sortName: 'estimate'
    },
    {
      title: 'Тип основания',
      isSortable: false,
      sortName: ''
    },
    {
      title: 'Основание',
      isSortable: false,
      sortName: ''
    },
    {
      title: 'МОЛ',
      isSortable: true,
      sortName: 'mol.surname'
    },
    {
      title: 'Дата получения сметы',
      isSortable: true,
      sortName: 'receive_date'
    },
    {
      title: 'Стоимость (в ценах 2001)',
      isSortable: true,
      sortName: 'price'
    },
    {
      title: 'Поставка заказчика',
      isSortable: true,
      sortName: 'customer_delivery'
    },
    {
      title: 'Индекс',
      isSortable: true,
      sortName: 'index'
    },
    {
      title: 'Стоимость (в тек.ценах без НДС)',
      isSortable: true,
      sortName: 'current_price'
    },
    {
      title: 'Трудозатраты',
      isSortable: true,
      sortName: 'labor_costs'
    }
  ]
})

const getters = {
  ...vuexPto.createGetters(),
  getCurrentItem: state => {
    return {
      ...state.currentItem,
      base_type: state.currentItem?.base_type ? mapEstimateBaseTypeItem(state.currentItem.base_type) : null
    }
  },
  getList: state => {
    return state.list.map(item => {
      const baseType = item.base_type ? mapEstimateBaseTypeItem(item.base_type) : null

      let base = item.base
      if (baseType && base) {
        switch (baseType.name) {
          case EPtoHandbookEstimateBaseTypeName.change: {
            base = base.number
            break
          }
          case EPtoHandbookEstimateBaseTypeName.document: {
            base = base.name
            break
          }
          case EPtoHandbookEstimateBaseTypeName.statement: {
            base = base.number
            break
          }
        }
      }

      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.estimate || '-',
          baseType?.name || '-',
          base || '-',
          getUserFullName(item.mol) || '-',
          item.receive_date || '-',
          priceFormat(item.price) || '-',
          priceFormat(item.customer_delivery) || '-',
          priceFormat(item.index) || '-',
          priceFormat(item.current_price) || '-',
          item.labor_costs || '-'
        ]
      }
    })
  }
}

const mutations = {
  ...vuexPto.createMutations()
}

const actions = {
  ...vuexPto.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    workSign,
    ownProduction,
    fotProduction
  }
}
